import { render, staticRenderFns } from "./OrphanClaimsTable.vue?vue&type=template&id=bb4064a8&scoped=true"
import script from "./OrphanClaimsTable.vue?vue&type=script&lang=js"
export * from "./OrphanClaimsTable.vue?vue&type=script&lang=js"
import style0 from "./OrphanClaimsTable.vue?vue&type=style&index=0&id=bb4064a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4064a8",
  null
  
)

export default component.exports